import { useConnect } from '@lore/query-connect';
import { user_networkId, user_tags_educator } from '@/utils/query-helpers';
import _ from 'lodash';

export default function useQuery(props) {
  const {
    network,
    pagination = {},
    params = {}
  } = props;

  return useConnect('note.find', {
    where: {
      eager: {
        $where: {
          userId: {
            $null: false
          },
          ..._.merge(
            {},
            user_networkId(network),
            user_tags_educator()
          ),
          ...params
        }
      }
    },
    ...pagination,
  }, {
    keepPreviousData: true
  });
}
